<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container-fulid text-center overflow-hidden">
  <div class="row justify-content-center">
    <div class="col-8">
      <h1 class="lifedi-color">
        จัดการคอร์สเรียน
      </h1>
    </div>
  </div>
  <div class="row d-flex pb-4 justify-content-center">
    <input type="text" class="form-control search" placeholder="ค้นหาคอร์สเรียน" name="searchCourse"
      [(ngModel)]="search" (keyup)="searching()">
    <lifedi-btn lable="เพิ่มคอร์สเรียน" (click)="addCourse()"
      customStyle="position: absolute; right: 3%; margin-top: 0px; padding: 0 25px; background: #005C3D; color:#FFFFFF">
    </lifedi-btn>
  </div>

  <nz-table #groupingTable [nzData]="rows" nzBordered nzSize="large" class="table table-striped"
    [nzFrontPagination]="false" [nzShowPagination]="false">
    <thead>
      <tr>
        <th class="text-center" *ngFor="let col of column">{{col.header}}</th>
      </tr>
    </thead>

    <!-- not search -->
    <tbody *ngIf="!isSearch">
      <tr *ngFor="let course of groupingTable.data; let i = index" (ngModelChange)="refresh()">
        <td class="text-center">{{ course[column[0].field] }}</td>
        <td class="text-center">
          <a [href]="locationUrl + '/e-learning/' + course[column[0].courseId]" target="_blank">
            {{ course[column[1].field] }}
          </a>
        </td>
        <td class="text-center">
          {{ course[column[2].field] | dateTime}}
          <span *ngIf="course[column[2].field2] && course[column[2].field2] !== '0000-00-00 00:00:00'">
            - {{ course[column[2].field2] | dateTime}}</span>
        </td>
        <td class="text-center">
          <span *ngIf="course[column[3].field] === 0">Active</span>
          <span *ngIf="course[column[3].field] === 1">Inactive</span>
          <span *ngIf="course[column[3].field] === 99">Draft</span>
          <span *ngIf="course[column[3].field] === 999">Incomplete</span>
        </td>
        <td class="text-center">
          {{ course[column[4].field] }}
        </td>
        <td class="text-center">
          {{ course[column[5].field] | number }}฿ / {{ course[column[5].field2] | number }}฿
        </td>
        <td class="text-center">
          <a style="cursor: pointer;" (click)="review(course[column[0].courseId])">
            <img src="../../../../assets/star.png" style="width: 20px;">
          </a>
        </td>
        <td class="text-center">
          <a style="cursor: pointer;" (click)="chat(course[column[0].courseId])">
            <img src="../../../../assets/chat-color.png" style="width: 20px;">
          </a>
        </td>
        <td class="text-center">
          <a style="cursor: pointer;" (click)="assign(course[column[0].courseId])">
            <img src="../../../../assets/document.png" style="width: 20px;">
          </a>
        </td>
        <td class="text-center">
          <a style="cursor: pointer;" (click)="edit(course[column[0].courseId])">
            <img src="../../../../assets/edit.png" style="width: 20px;">
          </a>
        </td>
        <td class="text-center">
          <a style="cursor: pointer;" (click)="privateChat(course[column[0].courseId])">
            <img src="../../../../assets/email-black.png" style="width: 20px;">
            <span *ngIf="course[column[10].field] > 0"
              [matBadge]="course[column[10].field] >= 99 ? '99+' : course[column[10].field]"
              matBadgeOverlap="false"></span>
          </a>
        </td>
      </tr>
    </tbody>

    <!-- search -->
    <tbody *ngIf="isSearch">
      <tr *ngFor="let course of groupingTable.data; let i = index" (ngModelChange)="refreshSearch()">
        <td class="text-center">{{ course[column[0].field] }}</td>
        <td class="text-center">
          <a [href]="locationUrl + '/e-learning/' + course[column[0].courseId]" target="_blank">
            {{ course[column[1].field] }}
          </a>
        </td>
        <td class="text-center">
          {{ course[column[2].field] | dateTime}} <span
            *ngIf="course[column[2].field2] && course[column[2].field2] !== '0000-00-00 00:00:00'">
            - {{ course[column[2].field2] | dateTime}}</span>
        </td>
        <td class="text-center">
          <span *ngIf="course[column[3].field] === 0">Active</span>
          <span *ngIf="course[column[3].field] === 1">Inactive</span>
          <span *ngIf="course[column[3].field] === 99">Draft</span>
          <span *ngIf="course[column[3].field] === 999">Incomplete</span>
        </td>
        <td class="text-center">
          {{ course[column[4].field] }}
        </td>
        <td class="text-center">{{ course[column[5].field] | number }} ฿ </td>
        <td class="text-center">
          <a style="cursor: pointer;" (click)="review(course[column[0].courseId])">
            <img src="../../../../assets/star.png" style="width: 20px;">
          </a>
        </td>
        <td class="text-center">
          <a style="cursor: pointer;" (click)="chat(course[column[0].courseId])">
            <img src="../../../../assets/chat-color.png" style="width: 20px;">
          </a>
        </td>
        <td class="text-center">
          <a style="cursor: pointer;" (click)="assign(course[column[0].courseId])">
            <img src="../../../../assets/document.png" style="width: 20px;">
          </a>
        </td>
        <td class="text-center">
          <a style="cursor: pointer;" (click)="edit(course[column[0].courseId])">
            <img src="../../../../assets/edit.png" style="width: 20px;">
          </a>
        </td>
        <td class="text-center">
          <a style="cursor: pointer;" (click)="privateChat(course[column[0].courseId])">
            <img src="../../../../assets/email-black.png" style="width: 20px;">
            <span *ngIf="course[column[10].field] > 0"
              [matBadge]="course[column[10].field] >= 99 ? '99+' : course[column[10].field]"
              matBadgeOverlap="false"></span>
          </a>
        </td>
      </tr>
    </tbody>

  </nz-table>

  <div class="d-flex justify-content-center p-2">
    <ngb-pagination *ngIf="!isSearch" [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize"
      (pageChange)="refresh()">
    </ngb-pagination>
    <ngb-pagination *ngIf="isSearch" [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize"
      (pageChange)="refreshSearch()">
    </ngb-pagination>
  </div>
  <select class="custom-select" style="width: auto; float: right; margin-right: 30px;" [(ngModel)]="pageSize"
    (ngModelChange)="refresh()">
    <option [ngValue]="10">10 items per page</option>
    <option [ngValue]="15">15 items per page</option>
    <option [ngValue]="20">20 items per page</option>
  </select>

  <mat-spinner *ngIf="!rows" class="spinner-center"></mat-spinner>
</div>
